import Lenis from 'lenis'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const scroll = {
    lenis: null,

    init() {
        let lastDirection = 0
        const root = document.documentElement
        const TOP_THRESHOLD = 60

        this.lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            smoothTouch: false,
        })

        root.classList.add('scroll-is-top')

        this.lenis.on('scroll', (e) => {
            ScrollTrigger.update()

            if (e.scroll <= TOP_THRESHOLD) {
                root.classList.add('scroll-is-top')
                root.classList.remove('scroll-up', 'scroll-down')
                lastDirection = 0
                return
            }

            root.classList.remove('scroll-is-top')

            if (e.direction !== lastDirection) {
                root.classList.remove('scroll-up', 'scroll-down')

                root.classList.add(
                    e.direction === 1 ? 'scroll-down' : 'scroll-up'
                )

                lastDirection = e.direction
            }
        })

        gsap.ticker.add((time) => this.lenis.raf(time * 1000))
        gsap.ticker.lagSmoothing(0)

        window.scroll = this

        this.initInView()
        this.initParallax()
        this.initFixedParallax()
        this.initFooterObserver()
    },

    initInView() {
        document.querySelectorAll('[data-inview]').forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 80%',
                end: 'bottom 20%',
                onEnter: () => el.classList.add('is-inview'),
                onLeaveBack: () => el.classList.remove('is-inview'),
            })
        })
    },

    initParallax() {
        document.querySelectorAll('[data-scroll-speed]').forEach((el) => {
            const speed = parseFloat(el.dataset.scrollSpeed) || 0

            gsap.set(el, {
                scale: 1.2,
                transformOrigin: 'center center',
            })

            gsap.to(el, {
                yPercent: speed,
                ease: 'none',
                scrollTrigger: {
                    trigger: el.parentElement,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                    invalidateOnRefresh: true,
                },
            })
        })
    },

    initFixedParallax() {
        document.querySelectorAll('[data-scroll-fixed]').forEach((el) => {
            const speed = parseFloat(el.dataset.scrollSpeed) || 1

            ScrollTrigger.create({
                trigger: el,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
                onUpdate: (self) => {
                    gsap.set(el, {
                        y: -ScrollTrigger.maxScroll(window) * (speed / 100) * self.progress,
                    })
                },
            })
        })
    },

    initFooterObserver() {
        const footer = document.querySelector('.js-footer')
        if (!footer) return

        ScrollTrigger.create({
            trigger: footer,
            start: 'top bottom',
            end: 'bottom bottom',
            onEnter: () => document.body.classList.add('is-footer'),
            onLeave: () => document.body.classList.remove('is-footer'),
            onEnterBack: () => document.body.classList.add('is-footer'),
            onLeaveBack: () => document.body.classList.remove('is-footer'),
        })
    },
}
